import {
  useKey
} from "./chunk-I754SZEB.mjs";

// lib/components/modal/modal-frame/modal-frame.tsx
import classnames from "classnames";
import { useId } from "react";
import ReactDOM from "react-dom";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
var ModalFrame = ({ title, isActive, isLarge, body, footer, onClose }) => {
  useKey("Escape", () => {
    onClose && onClose();
  });
  const id = useId();
  const titleId = `${id}-modal-title`;
  return /* @__PURE__ */ jsx(ModalPortal, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: classnames("modal", {
        "is-active": isActive
      }),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "modal-background",
            onClick: onClose,
            style: { backgroundColor: "rgba(10,10,10,0.6)" }
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: "modal-card",
            style: isLarge ? { width: "90vw", height: "90vh" } : void 0,
            role: "dialog",
            "aria-labelledby": titleId,
            children: [
              /* @__PURE__ */ jsx("div", { className: "modal-card-head has-text-centered", id: titleId, children: /* @__PURE__ */ jsx(
                "p",
                {
                  className: "title is-5 pt-1 pb-1",
                  style: {
                    marginLeft: "auto",
                    marginRight: "auto"
                  },
                  children: title
                }
              ) }),
              /* @__PURE__ */ jsx("section", { className: "modal-card-body", children: body }),
              /* @__PURE__ */ jsx("footer", { className: "modal-card-foot", children: footer })
            ]
          }
        )
      ]
    }
  ) });
};
var AscendModalContainerId = "ascend-modal-container-id";
var ModalContainer = () => /* @__PURE__ */ jsx("div", { id: AscendModalContainerId });
var ModalPortal = ({ children }) => {
  return ReactDOM.createPortal(
    children,
    document.getElementById(AscendModalContainerId) ?? document.body
  );
};

export {
  ModalFrame,
  ModalContainer
};
